// extracted by mini-css-extract-plugin
export default {"controls":"styles_controls__HFXNb","iconBtn":"styles_iconBtn__7QxSw","closeBtn":"styles_closeBtn__sE3N4","disabled":"styles_disabled__Mo3wL"};